import { useEffect } from "react";
import Chat from "./chat/Chat";
import PrysmChat from "./prysm/Chat";
import { isPrysmViewEnabled } from "../utils/viewMode";
import { setFavicon } from "../utils/favicon";
import jarvisIcon from "../../public/favicon-jarvis.ico";
import lipiIcon from "../../public/favicon.ico";
 
const AppEntry = () => {
  const isPrysmView = isPrysmViewEnabled();
 
  useEffect(() => {
    setFavicon(isPrysmView ? jarvisIcon : "lipiIcon");
 
    return () => {
      setFavicon("lipiIcon");
    };
  }, [isPrysmView]);
 
  return isPrysmView ? <PrysmChat /> : <Chat />;
};
 
export default AppEntry;